import { memberShipPlanStore } from "@/modules/setting/stores/onenetwork.store.memberShip.ts";

export const getFirstCharacterName = (name: string) => {
  if(!name) return '?';
  const _word = name.split(' ');
  if (_word?.length > 0) {
    return _word[_word.length - 1][0].toUpperCase();
  }
  return '?'
}


export function getRandomHexColor(): string {
  const randomColor = Math.floor(Math.random() * 0xffffff)
    .toString(16)
    .padStart(6, '0');
  return `#${randomColor}`;
}

export function hexWithOpacity(hex: string, opacity: number): string {
  const alpha = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0');

  return `${hex}${alpha}`;
}

export function beautyPhoneNumber(input: string): string {
  if (!input) return input;
  const splitChar = '.'
  // 1. Normalize input
  let cleaned = input.replace(/\D/g, '');
  if (cleaned.startsWith('84')) cleaned = '0' + cleaned.slice(2);

  if (cleaned.length !== 10 && cleaned.length !== 11) return input;

  const head = cleaned.slice(0, 3);
  const body = cleaned.slice(3);

  const formatWith = (...parts: string[]) => parts.join(splitChar);

  // 2. Danh sách các cụm số đẹp thường gặp
  const nicePatterns = ['68', '86', '39', '79', '66', '88', '999', '888', '6868', '8686', '7979', '3939', '9999', '5555'];

  // 3. Tìm cụm 4 số cuối đẹp
  const tail4 = body.slice(-4);
  if (nicePatterns.includes(tail4)) {
    return formatWith(head, body.slice(0, body.length - 4), tail4);
  }

  // 4. Tìm cụm 2 số cuối đẹp
  const tail2 = body.slice(-2);
  const mid = body.slice(0, body.length - 2);
  if (nicePatterns.includes(tail2)) {
    if (mid.length === 6) {
      return formatWith(head, mid.slice(0, 3), mid.slice(3), tail2);
    } else {
      return formatWith(head, mid, tail2);
    }
  }

  // 5. Default fallback: chia 3-3-4
  return formatWith(head, body.slice(0, 3), body.slice(3));
}

export const getMembershipPlanFilter = () => {
  const MembershipPlanStore = memberShipPlanStore()
  return MembershipPlanStore.membershipPlan.map(item => ({
    label: item.name,
    value: item.id,
  }))
}

export const getFullAddress = (province: any, district: any, ward: any) => {
  const parts: string[] = []

  if (ward?.name) parts.push(ward.name)
  if (district?.name) parts.push(district.name)
  if (province?.name) parts.push(province.name)

  return parts.join(', ')
}


